import {Platform, StyleSheet} from 'react-native';

import {indent} from '/constant/layout.constant';
import {cloudLight, denim} from '/theme/color/on.color';
import {codGray} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  heading: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    paddingVertical: indent * 0.5,
  },
  subHeading: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    flexShrink: 1,
    alignItems: 'center',
  },
  daysLeftContainer: {
    alignSelf: 'center',
  },
  daysLeft: {
    marginTop: indent * 0.2,
    marginLeft: indent * 0.25,
    fontSize: 12,
  },
  boxesContainerNew: {
    flexDirection: 'row',
    marginVertical: indent * 0.8,
    alignItems: 'stretch',
  },

  boxesContainer: {
    flexDirection: 'row',
    marginVertical: indent * 0.4,
    alignItems: 'stretch',
  },
  emptyBoxNew: {
    flex: 0,
    textAlign: 'center',
  },
  emptyBox: {
    flex: 1,
    textAlign: 'center',
  },
  lowerIntermidiateCSBNew: {
    flex: 1,
    textAlign: 'center',
    fontSize: 14,
    color: codGray,
  },

  lowerIntermidiateCSB: {
    flex: 1,
    textAlign: 'center',
  },
  centerIntermidiateCSB: {
    flex: 1,
    textAlign: 'center',
    fontSize: 14,
    color: codGray,
  },
  higherIntermidiateCSBNew: {
    flex: 1,
    textAlign: 'center',
    fontSize: 14,
    color: codGray,
  },

  higherIntermidiateCSB: {
    flex: 1,
    textAlign: 'center',
  },
  groupItemWithBorder: {
    top: 16,
    borderTopWidth: 1,
    borderTopColor: cloudLight,
  },
  emptyBoxesContainerReport: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    paddingTop: 32,
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    rowGap: indent * 0.25,
  },
  emptyBoxesContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    rowGap: indent * 0.25,
  },
  moneyBold: {
    fontWeight: '900',
    fontSize: 14,
  },
  boxTitle: {
    marginTop: indent * 0.4,
  },

  boxTitleNew: {
    marginTop: indent * 0.4,
    color: denim,
    fontWeight: '600',
  },
  link: {
    color: denim,
    fontWeight: '600',
    maxWidth: 120,
  },
  dateText: {
    fontSize: Platform.select({android: 12, ios: 16}),
  },
  fcvText: {
    fontSize: Platform.select({android: 12, ios: 14}),
    flexShrink: 1,
    marginTop: indent * 0.1,
  },
  base: {
    width: '100%',
  },
  fcvContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingBottom: indent * 0.25,
    marginVertical: indent * 0.3,
    marginHorizontal: indent * 0.2,
  },
  bbbFcvText: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    fontSize: Platform.select({android: 12, ios: 14}),
    alignItems: 'center',
  },
  bbbDaysLeft: {
    alignSelf: 'center',
    marginLeft: indent * 0.5,
    fontSize: 12,
  },
});
